import { ArrowRight, X } from 'lucide-react';
import React from 'react';
import { createPortal } from 'react-dom';
import styles from './DashboardCreationModal.module.scss';
import {
    CustomerRetention, EcommerceOverview,
    MarketingFocus
} from './initSchema';

// Icons
import BustlyAiLogo from '@/assets/images/dashboard/Bustly_ai.svg';

// Template Images
import Template1Img from '@/assets/images/dashboard/Dashboard模板1.png';
import Template1Icon from '@/assets/images/dashboard/Dashboard模板1图标.svg';
import Template2Img from '@/assets/images/dashboard/Dashboard模板2.png';
import Template2Icon from '@/assets/images/dashboard/Dashboard模板2图标.svg';
import Template3Img from '@/assets/images/dashboard/Dashboard模板3.png';
import Template3Icon from '@/assets/images/dashboard/Dashboard模板3图标.svg';

interface DashboardCreationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSelectTemplate: (template: any) => void;
}

export const DashboardCreationModal: React.FC<DashboardCreationModalProps> = ({
    isOpen,
    onClose,
    onSelectTemplate,
}) => {
    if (!isOpen) return null;

    const templates = [
        {
            id: 'ecommerce',
            title: 'E-commerce Overview',
            description: 'A quick snapshot of sales, orders, AOV, and refunds—your store’s core health.',
            image: Template1Img,
            iconImg: Template1Icon,
            schema: EcommerceOverview
        },
        {
            id: 'marketing',
            title: 'Marketing Focus',
            description: 'Track spend, conversions, and ROAS to spot what’s working—and where the funnel drops.',
            image: Template2Img,
            iconImg: Template2Icon,
            schema: MarketingFocus
        },
        {
            id: 'customer',
            title: 'Customer & Retention',
            description: 'Understand new vs returning customers, repeat rate, and customer value to grow retention.',
            image: Template3Img,
            iconImg: Template3Icon,
            schema: CustomerRetention
        },
        // {
        //     id: 'init',
        //     title: 'Business Overview',
        //     description: 'A quick snapshot of sales, orders, AOV, and refunds—your store’s core health.',
        //     image: Template3Img,
        //     iconImg: Template3Icon,
        //     schema: INIT_SCHEMA
        // }
    ];

    return createPortal(
        <div className={styles.modalOverlay} onClick={onClose}>
            <div 
                className={styles.modalContent} 
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.modalHeader}>
                    <h3>Generate Dashboard</h3>
                    <button onClick={onClose} className={styles.closeButton}>
                        <X size={20} />
                    </button>
                </div>

                <div className={styles.modalBody}>
                    <div className={styles.topActions}>
                        <button onClick={() => onSelectTemplate({})} className={styles.aiButton}>
                            <div className={styles.aiIconWrapper}>
                                <img src={BustlyAiLogo} alt="Bustly AI" />
                            </div>
                            <div>
                                <div className={styles.aiTitle}>Build with AI</div>
                                <div className={styles.aiDescription}>Generate with Bustly AI</div>
                            </div>
                        </button>
                    </div>

                    <div className={styles.section}>
                        <h3 className={styles.sectionTitle}>Suggested</h3>
                        <div className={styles.templatesGrid}>
                            {templates.map((template) => (
                                <div 
                                    key={template.id}
                                    onClick={() => onSelectTemplate(template)}
                                    className={styles.templateCard}
                                >
                                    <div className={styles.imageSection}>
                                        <img src={template.image} alt={template.title} />
                                    </div>
                                    <div className={styles.contentSection}>
                                        <div className={styles.templateHeader}>
                                            <img src={template.iconImg} alt="" />
                                            <h3>{template.title}</h3>
                                        </div>
                                        <p className={styles.description}>{template.description}</p>
                                        <div className={styles.footer}>
                                            Use Template 
                                            {' '}
                                            <ArrowRight size={12} className="ml-1" />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};
